import { ExporterDataInput } from '@gtpl/shared-models/logistics';
import { ContainerRegisterService } from '@gtpl/shared-services/logistics';
import { Button, Card } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react'

export interface SpsaPackingLIstProps{
    saleOrderId?:number;
}

const SpsaPackingList = (props: SpsaPackingLIstProps) => {
    const [packingData,setPackingData]=useState<any>([]);
    const logisticsService = new ContainerRegisterService();
    

    useEffect(() => {
    if (props.saleOrderId) {
      getSpsaPackingPrint();
    }
  }, [props.saleOrderId]);

    const getSpsaPackingPrint=()=>{
        logisticsService.getSpsaPackingPrint({saleOrderId:props.saleOrderId}).then((res)=>{
            if(res.status){
            setPackingData(res.data);
            }else{
                setPackingData([]);
            }
        }).catch((err)=>{
            console.log(err);
            setPackingData([]);
        }
        )
    }

    const idToFind = packingData.header?.exporterId ?  packingData.header.exporterId : packingData?.header?.unitId;
    let exporterDetails = ExporterDataInput;
    const exporterData = exporterDetails.find(item => item.value === idToFind);

      const getCssFromComponent = (fromDoc: Document, toDoc: Document) => {
    Array.from(fromDoc.styleSheets).forEach((styleSheet: CSSStyleSheet) => {
      try {
        if (styleSheet?.cssRules) { // true for inline styles and same-origin stylesheets
          const newStyleElement = toDoc.createElement("style");
          Array.from(styleSheet.cssRules).forEach((cssRule: CSSRule) => {
            newStyleElement.appendChild(toDoc.createTextNode(cssRule.cssText));
          });
          toDoc.head.appendChild(newStyleElement);
        }
      } catch (e) {
        console.warn("Could not access stylesheet rules for", styleSheet.href, e);
      }
    });
  };

const printOrder = () => {

  const divContents =
    document.getElementById('printme')?.innerHTML;

  const printWindow = window.open(
    '',
    '',
    'height=900,width=1200'
  );

  printWindow.document.write(`
  <html>
  <head>
      <title>Packing List</title>

      <style>

      body{
        margin:0;
        padding:0;
        font-size:11px;
      }

      table{
        width:100%;
        border-collapse:collapse;
      }

      tr{
        page-break-inside:avoid;
      }

      .packing-abstract{
         page-break-inside:avoid;
      }

      @media print{

         body{
          zoom:85%;
        }

        tr{
          page-break-inside:avoid;
        }

        .packing-abstract{
           page-break-inside:avoid;
        }

        .print-page{
           page-break-after:always;
        }

      }

      </style>

  </head>

  <body>

      ${divContents}

  </body>

  </html>
  `);

  getCssFromComponent(
      document,
      printWindow.document
  );

  printWindow.document.close();

  setTimeout(() => {

      printWindow.focus();

      printWindow.print();

      printWindow.close();

  },1000);

};
const showPackingAbstract =packingData.pages?.length > 1;

  return (
    <div>
                <Card  title="PACKING LIST"
                        style={{ textAlign: 'center' }}
                        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
                        extra={
                          <span style={{ color: 'white' }}>
                            <Button onClick={printOrder} className="panel_button">
                              Print
                            </Button>
                          </span>
                        }>
        <body>
            <>
            <div id="printme">
            {packingData.pages?.map((page: any, pageIndex: number) => {
              const isLastPage =
  pageIndex === packingData.pages.length - 1;
              return(

             
        <div
        
          key={pageIndex}
           className={
     pageIndex !== packingData.pages.length-1
       ? 'print-page'
       : ''
  }
          style={{
            pageBreakAfter: 'always',
    //         pageBreakAfter:
    // pageIndex !== packingData.pages.length - 1
    //   ? 'always'
    //   : 'auto',
            padding: '10px',
          }}
        >
            <table style={{width:'100%',border:'1px solid black',borderCollapse:'collapse'}}>
                <tr>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}} colSpan={6}>PACKING LIST</th>
                </tr>
                <tr>
                    <td style={{border:'1px solid black',borderCollapse:'collapse'}} colSpan={3} rowSpan={3}>
                        <div><b>Exporter</b></div>
                        <div>{exporterData?.name}</div>
                                <div>{exporterData?.addressOne}</div>
                                <div>{exporterData?.addressTwo}</div>
                                <div>{exporterData?.state} - {exporterData?.postalCode}</div>
                                <div>{exporterData?.country}</div>
                                <div>PH: {exporterData?.phoneNumber}</div>
                    </td>
                    <td style={{border:'1px solid black',borderCollapse:'collapse'}} colSpan={3}>
                        <div><b>Invoice No. & Date</b></div>
                        <div>{packingData.header?.invoiceNo} DATED :{moment(packingData.header?.invoiceDate)?.format('DD-MM-YYYY')}</div>
                    </td>
                </tr>
                <tr>
                    <td style={{border:'1px solid black',borderCollapse:'collapse'}} colSpan={3} >
                        <div><b>SALES CONTRACT:{packingData.header?.salesContract} DATED :{moment(packingData.header?.salesContractDate)?.format('DD-MM-YYYY')}</b></div>
                    </td>
                    </tr>
                    <tr>
                    <td style={{border:'1px solid black',borderCollapse:'collapse'}} colSpan={3}>
                        <div><b>Other Reference.</b></div>
                        <div>&nbsp;</div>
                    </td>
                </tr>
                <tr>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}}>MARKS & NOS</th>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}}>KIND OF PKGS</th>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}}>DESCRIPTION OF GOODS</th>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}}>BALE(Nos) </th>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}}>GR WGT</th>
                    <th style={{border:'1px solid black',borderCollapse:'collapse'}}>NT WGT</th>
                </tr>
            <tbody>
              {page.rows?.map((row: any, index: number) => (
                <tr key={index}>
                  <td style={{textAlign:"center", borderLeft: '1px solid black',
  borderRight: '1px solid black'}}>
                     {index === 0 ? packingData.header?.marksAndNo : ''}
                  </td>

                  <td style={{textAlign:"center", borderLeft: '1px solid black',
  borderRight: '1px solid black'}}>
                    {index === 0 ? row.packageType: ''}{index === 0?row.cases ? ` - ${row.cases} ` : '': ''}
                  </td>

                  <td style={{textAlign:"center", borderLeft: '1px solid black',
  borderRight: '1px solid black'}}>
                     {index === 0 ? page.productDescription : ''}
                  </td>

                  <td style={{textAlign:"center", borderLeft: '1px solid black',
  borderRight: '1px solid black'}}>
                    {row.sequence}{row.pack_list_no}
                  </td>

                  <td style={{textAlign:"center", borderLeft: '1px solid black',
  borderRight: '1px solid black'}}>
                    {(
                      Number(row.netWeight || 0) +
                      Number(row.tare_weight || 0)
                    ).toFixed(2)}
                  </td>

                  <td style={{textAlign:"center", borderLeft: '1px solid black',
  borderRight: '1px solid black'}}>
                    {Number(row.netWeight || 0).toFixed(2)}
                  </td>
                </tr>
              ))}

              {/* Empty rows to make fixed 40 row page */}
              
{
Array.from({
  length: Math.max(
    0,
    isLastPage
      ? 20 - page.rows.length
      : 39 - page.rows.length
  )
}).map((_, idx) => (

<tr key={`empty-${idx}`}>

  <td style={dataCellStyle}></td>

  <td style={dataCellStyle}></td>

  <td style={dataCellStyle}></td>

  <td style={dataCellStyle}></td>

  <td style={dataCellStyle}></td>

  <td style={dataCellStyle}></td>

</tr>

))
}
                  </tbody>

           
                    <tr>
                        <th style={{border:'1px solid black',borderCollapse:'collapse'}} colSpan={4}>TOTAL {page.totalBales} BALES</th>
                        <th style={styles.th}>{page.totalGrossWeight?.toFixed(2)}</th>
                        <th style={styles.th}>{page.totalNetWeight?.toFixed(2)}</th>
                    </tr>


{isLastPage && showPackingAbstract && (
  <>
    <tr>
      <td
        colSpan={6}
        style={{
          borderLeft: '1px solid black',
          borderRight: '1px solid black',
          height: '10px'
        }}
      />
    </tr>

    <tr>
      <th
        colSpan={6}
        style={{
          border: '1px solid black',
          textAlign: 'center'
        }}
      >
        PACKING ABSTRACT
      </th>
    </tr>
  </>
)}
{isLastPage && showPackingAbstract &&
<tr >

      
        <th
        colSpan={2}
          style={styles.th}
        >
          DESCRIPTION
        </th>

      <th style={styles.th} colSpan={2}>
       BALE RANGE
      </th>

      <th style={styles.th}>
        GROSS WEIGHT
      </th>

      <th style={styles.th}>
        NET WEIGHT
      </th>

    </tr>
 }
{isLastPage && showPackingAbstract &&
 packingData.packingAbstract?.map(
  (item,index) => {

   const showDescription =
    index === 0 ||
    packingData.packingAbstract[index-1]
      ?.saleOrderItemId !== item.saleOrderItemId;

   return (
    <tr key={index}>

      {showDescription && (
        <td
        colSpan={2}
          rowSpan={item.rowspan}
          style={styles.td}
        >
          {item.productDescription}
        </td>
      )}

      <td style={styles.td} colSpan={2}>
        {item.baleRange}
      </td>

      <td style={styles.td}>
        {item.totalGrossWeight?.toFixed(2)}
      </td>

      <td style={styles.td}>
        {item.totalNetWeight?.toFixed(2)}
      </td>

    </tr>
   );
 })}
 {isLastPage && showPackingAbstract && (
<tr>
  <th style={styles.th} colSpan={2}>
    TOTAL
  </th>
   <th style={styles.th} colSpan={2}>
    {
      packingData.pages?.reduce(
        (sum, page) => sum + Number(page.totalBales || 0),
        0
      )
    } BALES
  </th>

  <th style={styles.th}>
    {packingData.packingAbstract
      ?.reduce(
        (sum,item)=>sum+item.totalGrossWeight,
        0
      )
      ?.toFixed(2)}
  </th>

  <th style={styles.th}>
    {packingData.packingAbstract
      ?.reduce(
        (sum,item)=>sum+item.totalNetWeight,
        0
      )
      ?.toFixed(2)}
  </th>
</tr>
)}
{/* <tr>
  <td
    colSpan={6}
    style={{
      borderLeft:'1px solid black',
      borderRight:'1px solid black',
      height:'30px'
    }}
  />
</tr> */}

<tr>
  <td
    colSpan={6}
    style={{
      textAlign:'right',
      borderLeft:'1px solid black',
      borderRight:'1px solid black',
      borderTop:"1px solid black",
      fontWeight:'bold'
    }}
  >
    FOR SPSA SILKS PVT. LTD.
  </td>
</tr>

<tr>
  <td
    colSpan={6}
    style={{
      textAlign:'right',
      borderLeft:'1px solid black',
      borderRight:'1px solid black',
      fontWeight:'bold'
    }}
  >
&nbsp;  </td>
</tr>

<tr>
  <td
    colSpan={6}
    style={{
      textAlign:'right',
      borderLeft:'1px solid black',
      borderRight:'1px solid black',
      fontWeight:'bold'
    }}
  >
    AUTHORIZED SIGNATORY
  </td>
</tr>
</table>

</div>
);
})}


            </div>
            </>
        </body>
        </Card>
    </div>
  )
}

const dataCellStyle = {
  borderLeft: '1px solid black',
  borderRight: '1px solid black',
  borderTop: 'none',
  borderBottom: 'none',
  textAlign: 'center' as const,
  height: '22px'
};

const styles = {
  th: {
    border: '1px solid black',
    padding: '5px',
    textAlign: 'center' as const,
  },

  td: {
    border: '1px solid black',
    padding: '5px',
    textAlign: 'center' as const,
  },
};

export default SpsaPackingList